import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/pages/Home';
import MixologyPage from '@/pages/MixologyPage';
import RecipesPage from '@/pages/RecipesPage';
import AgeGatePage from '@/pages/AgeGatePage';
import Pride from '@/pages/Pride';

import Contact from '@/pages/Contact';


Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/mixology',
      name: 'mixology-page',
      component() {
        if (sessionStorage.getItem('ofAge')) {
          return import('../pages/MixologyPage')
          ;
        } else {
          return import('../pages/AgeGatePage')
        }
      },
    },
    {
      path: '/recipes',
      name: 'recipes-page',
      component: RecipesPage,
    },
    {
      path: '/agegate',
      name: 'agegate-page',
      component: AgeGatePage,
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact,
    },
    {
      path: '/pride',
      name: 'pride',
      component: Pride,
    }
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js